import { createApp } from 'vue';
import JoinUsQuestion from "../components/JoinUsQuestion.vue";
import Select2 from "../components/Select2";
import Postcode from "../components/Postcode.vue";
window.plupload = require('plupload');

let enquiry = createApp({
    name: 'join-us-section',
    components: {
        'join-us-question': JoinUsQuestion,
        'select2': Select2,
        'postcode': Postcode,
    },
    data() {
        return {
            form_questions: app.form_questions,
            form: {},
            errors: [],
            success_message: '',
            in_progress: false,
            upload_status: null,
            upload_response: null,
            upload_status2: null,
            upload_response2: null,
        };
    },

    mounted: function () {
        let vm = this;

        this.initForm();

        new plupload.Uploader({
            browse_button: 'pick_cv_file',
            max_file_size: '20mb',
            multi_selection: false,
            url: '/join-us/upload-file',
            filters: {
                mime_types: [
                    { title: "Documents", extensions: "pdf,doc,docx" },
                ]
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            init: {
                FilesAdded: function (up, files) {
                    vm.upload_status = "started";

                    up.start();
                    up.refresh(); // Reposition Flash/Silverlight
                },

                FileUploaded: function (up, file, res) {
                    vm.upload_response = $.parseJSON(res.response);
                    vm.upload_response.name = file.name; //overwrite name, to be the original one
                    vm.form.cv_path = vm.upload_response.path;

                    vm.upload_status = "finished";
                },

                Error: function (up, err) {
                    console.error(err);
                    vm.upload_status = "error";
                }
            }
        }).init();

        new plupload.Uploader({
            browse_button: 'pick_supporting_statement_file',
            max_file_size: '20mb',
            multi_selection: false,
            url: '/join-us/upload-file',
            filters: {
                mime_types: [
                    { title: "Documents", extensions: "pdf,doc,docx" },
                ]
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            init: {
                FilesAdded: function (up, files) {
                    vm.upload_status2 = "started";

                    up.start();
                    up.refresh(); // Reposition Flash/Silverlight
                },

                FileUploaded: function (up, file, res) {
                    vm.upload_response2 = $.parseJSON(res.response);
                    vm.upload_response2.name = file.name; //overwrite name, to be the original one
                    vm.form.supporting_statement_path = vm.upload_response2.path;

                    vm.upload_status2 = "finished";
                },

                Error: function (up, err) {
                    console.error(err);
                    vm.upload_status2 = "error";
                }
            }
        }).init();

    },

    methods: {

        onQuestionAnswer: function(data) {
            this.form['question-' + data.key] = data.value;
        },

        submit: function () {
            let vm = this;

            if (vm.in_progress) {
                return;
            }

            vm.errors = [];
            vm.in_progress = true;
            vm.success_message = '';

            axios.post('/join-us', vm.form)
                .then(function (response) {
                    vm.success_message = response.data.message;

                    // reset form data
                    vm.initForm();
                })
                .catch(function (error) {
                    vm.displayErrors(error)
                }).then(function () {
                vm.in_progress = false;
                vm.generateRecaptchaToken();
            });
        },

        initForm: function() {
            let vm = this;

            vm.form = this.getFormTemplate();
            vm.addReCaptchaKey();

            // regenerate recaptcha token every 2 minutes, so it doesn't expire
            setInterval(function() {
                vm.generateRecaptchaToken();
            }, 2 * 60 * 1000);
        },

        displayErrors: function (error) {
            let vm = this;

            if (error.response.data.errors) {
                _.forEach(error.response.data.errors, function (error) {
                    vm.errors.push(error[0]);
                });
            } else {
                // Something happened in setting up the request that triggered an Error
                vm.errors.push("An error occurred while processing your request. Please contact support.");
            }
        },

        getFormTemplate: function() {
            let template = {
                first_name: '',
                last_name: '',
                title: '',
                email: '',
                phone: '',
                address_postcode: '',
                address_latitude: null,
                address_longitude: null,
                address_line_1: '',
                address_line_2: '',
                address_city: '',
                county_id: '',
                notes: '',
                discipline_id: '',
                cv_path: '',
                supporting_statement_path: '',
                hear_about_us: '',
                terms_and_conditions: false,
                coordinates: null,
            };

            _.each(app.questions_codes, function (code) {
                template['question-' + code] = '';
            });

            return template;
        },

        addReCaptchaKey: function () {
            let vm = this;
            grecaptcha.ready( () => {
                vm.generateRecaptchaToken();
            });
        },

        generateRecaptchaToken: function() {
            grecaptcha.execute(app.recaptcha_public, {action: 'joinform'}).then( token => {
                this.form['g-recaptcha-response'] = token;
            });
        },
    }
}).mount(".join-us-section");
